import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RolePermissionResponse, AssignPermissionsRequest } from '../models/permission';
import { RolePermission } from './role-permission-bridge.service';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionApiService {
  private readonly baseUrl = `${environment.apiUrl}/role-permissions`;

  constructor(private http: HttpClient) {}

  /**
   * Get all permissions for a specific role
   */
  getRolePermissions(roleId: number): Observable<RolePermissionResponse> {
    return this.http.get<RolePermissionResponse>(`${this.baseUrl}/role/${roleId}`);
  }

  /**
   * Assign permissions to a role (replaces existing permissions)
   */
  assignPermissionsToRole(roleId: number, permissionIds: number[]): Observable<void> {
    const request: AssignPermissionsRequest = { roleId, permissionIds };
    return this.http.post<void>(`${this.baseUrl}/role/${roleId}`, request);
  }

  /**
   * Update role permissions (replaces existing permissions)
   */
  updateRolePermissions(roleId: number, permissionIds: number[]): Observable<RolePermissionResponse> {
    const request: AssignPermissionsRequest = { roleId, permissionIds };
    return this.http.put<RolePermissionResponse>(`${this.baseUrl}/role/${roleId}`, request);
  }

  /**
   * Remove all permissions from a role
   */
  removeAllPermissionsFromRole(roleId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/role/${roleId}`);
  }

  /**
   * Add specific permissions to a role (additive)
   */
  addPermissionsToRole(roleId: number, permissionIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/role/${roleId}/add`, { permissionIds });
  }

  /**
   * Remove specific permissions from a role
   */
  removePermissionsFromRole(roleId: number, permissionIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/role/${roleId}/remove`, { permissionIds });
  }

  /**
   * Get all role-permission assignments
   */
  getAllRolePermissions(): Observable<RolePermissionResponse[]> {
    return this.http.get<RolePermissionResponse[]>(this.baseUrl);
  }
}


